import { BrandNav, SiteFooter } from './SiteChrome';

export const LegalPage = ({ title, sections, testId }) => (
  <div className="min-h-screen bg-black flex flex-col">
    <BrandNav width="max-w-4xl" />
    <main className="flex-1 max-w-4xl mx-auto px-4 py-10 w-full">
      <h1 className="text-2xl font-bold mb-2" data-testid={testId}>{title}</h1>
      <p className="text-xs text-zinc-500 mb-8">Trade PMI by Standards Protocol</p>
      <div className="space-y-4 text-zinc-400">
        {sections.map((s) => (
          <section key={s.h} className={`bg-zinc-950 border rounded-lg p-5 ${s.warn ? 'border-brand/40' : 'border-zinc-800'}`}>
            <h2 className={`text-base font-bold mb-3 ${s.warn ? 'text-brand' : 'text-white'}`}>{s.h}</h2>
            {s.p && <p className="text-sm leading-relaxed">{s.p}</p>}
            {s.list && (
              <ul className="list-disc list-inside text-sm mt-2 space-y-1">
                {s.list.map((li) => <li key={li}>{li}</li>)}
              </ul>
            )}
          </section>
        ))}
      </div>
    </main>
    <SiteFooter />
  </div>
);
